<template>
    <Multiselect
        ref="orgMultiSelector"
        :model-value="selected"
        :options="sortedOrgs"
        :allow-empty="false"
        track-by="organizationId"
        label="organizationName"
        select-label=""
        placeholder="Søk etter virksomhet"
        class="org-selector"
        :close-on-select="true"
        @select="setOrg"
    >
        <template #singleLabel="{option}">
            <div data-cy="header-selected-org-indicator" class="text-sm truncate">{{ option.value?.organizationName }}</div>
        </template>
        <template #option="props">
            <div :class="{'selected-org': props.option.organizationId === selectedOrg?.organizationId}">
                <div class="flex justify-between">
                    <div>
                        {{ props.option.organizationName }}
                    </div>
                    <i v-if="props.option.organizationId === selectedOrg?.organizationId" class="i-ph-check text-xs"/>
                </div>
            </div>
        </template>
        <template #afterList="{}">
            <div id="org-selector-after-list" class="flex justify-between mt-2 px-2">
                <targeting-router-link
                    class="btn btn-sm w-fit"
                    :to="ORGS"
                    data-cy="org-selector-overview-button"
                    @click="closeSelector"
                >
                    <i class="i-ph-buildings"/>
                    Oversikt
                </targeting-router-link>
                <a
                    class="btn btn-sm btn-primary w-fit"
                    :href="REGISTER_ORG"
                    data-cy="register-new-organization-button"
                    @click="closeSelector"
                >
                    <i class="i-ph-plus text-primary-content"/>
                    <span class="text-primary-content">Ny</span>
                </a>
            </div>
        </template>
        <template #noResult="{}">Ingen virksomhet funnet</template>
    </Multiselect>
</template>
<script setup lang="ts">
import {computed, ref} from 'vue'
import _ from 'lodash'
import {myOrgs, selectedOrg, switchOrg} from '@/tenants/org.service'
import {Tenant} from '@/tenants/Tenant'
import Multiselect from 'vue-multiselect'
import {ORGS, REGISTER_ORG} from '@/tenants'
import { TargetingRouterLink } from '@tritt/multipanel'

const orgMultiSelector = ref<InstanceType<typeof Multiselect> | null>(null)


// TODO: Need help with typing this one... :(
const selected = computed<Tenant | undefined>(() => {
    return selectedOrg as any
})


const setOrg = (org: Tenant) => {
    if (org.isProvisioned) {
        switchOrg(org)
    } else {
        alert('Forsøkte å velge et foretak som ikke er opprettet i Conta Pro. Dette er en bug og skal ikke skje. Vennligst rapporter til support/utvikling. \n + Org: ' + org)
    }
}

const closeSelector = () => {
    if (orgMultiSelector.value) {
        orgMultiSelector.value.deactivate()
    }
}

const sortedOrgs = computed(() => {
    return _.sortBy(myOrgs.value, 'organizationName')
})

</script>

<style src="vue-multiselect/dist/vue-multiselect.css"></style>

<style>
@reference "@/index.css";
@reference "tailwindcss";

.org-selector {

    &.multiselect {
        @apply border-none text-base-content text-sm;
    }

    .multiselect__tags {
        @apply bg-base-100 border-none;
    }

    .multiselect__content {
        @apply bg-base-100 py-2;
    }

    .multiselect__element {
        .selected-org {
            @apply text-primary;
        }
        .multiselect__option--highlight {
            @apply bg-primary text-primary-content;
            .selected-org {
                @apply text-base-100;
            }
        }
    }

    .multiselect__input, .multiselect__single, .multiselect__input::placeholder {
        @apply bg-base-100 text-base-content;
    }

    .multiselect__content-wrapper {
        @apply shadow-2xl border-none;
    }

    i {
        @apply text-xl mr-1;
    }
}
</style>
